export class CostoFacturacionVariacion {
  cantidad_variacion:number=0;
  costo_generado_unitario:number=0
  costo_generado_total:number=0;
  es_aumento_usuarios:boolean =true;
  fecha_variacion:string='';
}
